import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, lineHeight } from 'stylesheet';
import { Minus, Plus } from 'theme/icons';
var SelectedItemAndRetailerContainer = styled.div.withConfig({
  displayName: "SelectedItemAndRetailerstyle__SelectedItemAndRetailerContainer",
  componentId: "sc-l4vwei-0"
})(["position:relative;display:flex;align-items:center;justify-content:space-between;width:500px;margin-top:", ";padding:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(1), getSpacing(1), colorUsage.searchItemList.borderColor, borderRadius.medium);
var NumberInputContainer = styled.div.withConfig({
  displayName: "SelectedItemAndRetailerstyle__NumberInputContainer",
  componentId: "sc-l4vwei-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;"]);
var ItemTitle = styled.div.withConfig({
  displayName: "SelectedItemAndRetailerstyle__ItemTitle",
  componentId: "sc-l4vwei-2"
})(["font-weight:bold;"]);
var ItemSubTitle = styled.div.withConfig({
  displayName: "SelectedItemAndRetailerstyle__ItemSubTitle",
  componentId: "sc-l4vwei-3"
})(["height:", ";overflow:hidden;color:", ";"], lineHeight.normal, colorUsage.searchItemList.subTitleColor);
var ItemInvalid = styled(ItemSubTitle).withConfig({
  displayName: "SelectedItemAndRetailerstyle__ItemInvalid",
  componentId: "sc-l4vwei-4"
})(["color:", ";"], colorUsage.message.error);
var PlusIcon = styled(Plus).withConfig({
  displayName: "SelectedItemAndRetailerstyle__PlusIcon",
  componentId: "sc-l4vwei-5"
})(["width:12px;height:12px;cursor:pointer;& path{fill:", ";}"], colorUsage.grayDark);
var MinusIcon = styled(Minus).withConfig({
  displayName: "SelectedItemAndRetailerstyle__MinusIcon",
  componentId: "sc-l4vwei-6"
})(["width:12px;height:12px;cursor:pointer;& path{fill:", ";}"], colorUsage.grayDark);
export { ItemInvalid, ItemSubTitle, ItemTitle, MinusIcon, NumberInputContainer, PlusIcon, SelectedItemAndRetailerContainer };